// src/utils/firebase.web.js - Web-compatible Firebase config
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  initializeAuth, 
  browserLocalPersistence, // Use browser persistence instead of React Native persistence
  setPersistence,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase config (use the same config as your mobile app)
const firebaseConfig = {
  // Copy your Firebase config here from your existing firebase.js
  // Replace with your Firebase config
  apiKey: "AIzaSyCDyqkLY7_U7y6GIPVKPYQTlVg5S8mrNEE",
  authDomain: "webview-app-9c59d.firebaseapp.com",
  projectId: "webview-app-9c59d",
  storageBucket: "webview-app-9c59d.firebasestorage.app",
  messagingSenderId: "615539754430",
  appId: "1:615539754430:web:aa57dc073520bdf02ea5ef"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with browser persistence
const auth = getAuth(app);

// Set persistence for web
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.log("Persistence error:", error);
});

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

export { 
  auth, 
  db, 
  storage,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged
};